module.exports = __webpack_public_path__ + "img/Animations.95d01fe9.svg";